import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFieldDetail } from '../../../interfaces/fields/field/field-detail.model';
import { IHoldingSelectList } from '../../../interfaces/fields/field/holding-select-list.model';
import { ISelectList } from '../../../shared/models/select-list.model';

import { FieldService } from '../../../shared/services/fields/field.service';
import { IntercomService } from '../../../shared/services/intercom/intercom.service';
import { MessageService } from '../../../shared/services/message/message.service';
import { GatekeeperModalComponent } from '../../modal.component';

@Component({
  selector: 'gk-add-field-modal',
  templateUrl: './add-field-modal.html'
})
export class AddFieldModalComponent
  extends GatekeeperModalComponent<AddFieldModalComponent>
  implements OnInit
{
  fieldDetails: IFieldDetail;
  farmList: Array<ISelectList> = [];
  holdingList: Array<IHoldingSelectList> = [];
  addAnother: boolean;

  constructor(
    private messageService: MessageService,
    private fieldService: FieldService,
    private intercomService: IntercomService,
    public dialogRef: MatDialogRef<AddFieldModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
  }

  ngOnInit() {
    this.addAnother = this.data.locals.addAnother;
    if (!this.addAnother) {
      this.fieldService
        .getFieldLookups()
        .then(() => this._setLists())
        .then(() => this.setupForNewField());
    } else {
      this._setLists();
      this.setupForNewField();
    }
  }

  setupForNewField() {
    this.fieldDetails = <IFieldDetail>{};

    if (this.addAnother && this.fieldService.lastNvzRegion) {
      this.fieldDetails.nvzFieldRegionId = this.fieldService.lastNvzRegion;
    }
    if (this.holdingList.length === 1) {
      this.fieldDetails.holdingId = this.holdingList[0].id;
      this.fieldDetails.businessId = this.holdingList[0].businessId;
    }
  }

  saveField() {
    this.fieldService
      .createField(this.fieldDetails)
      .then(response => {
        this.messageService.showIcon(MessageTypeEnum.Success);
        this.intercomService.markToFetchDetails();
        if (this.addAnother) {
          this.dialogRef.close({ addAnother: true });
        } else {
          this.dialogRef.close({ addAnother: false, id: response[0] });
        }
      })
      .catch(() => {
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'FIELDS_SAVE_ERROR'
        );
      });
  }

  private _setLists() {
    this.holdingList = this.fieldService.holdingList;
  }
}
